import React from "react";
import { Clear } from "@bolteu/kalep-react-icons";
import { GhostButton } from "../GhostButton";
import { cx } from "../../helpers/utils/cx";
export const MultiSelectChip = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    label,
    disabled,
    shrink,
    hidden,
    size,
    onDelete
  } = _ref;
  const handleClickDelete = React.useCallback(_e => {
    onDelete?.();
  }, [onDelete]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cx("flex items-center gap-[6px]", "box-border px-[6px] py-[2px] rounded-md border-solid border-2 border-neutral-secondary whitespace-nowrap", size === "sm" ? "bolt-font-body-xs-regular" : "bolt-font-body-s-regular", shrink ? "text-ellipsis overflow-hidden flex-shrink-1" : "flex-shrink-0 overflow-auto", disabled ? "text-tertiary" : "text-primary bg-neutral-secondary", hidden && "invisible", "overflow-y-hidden")
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("truncate")
  }, label), typeof onDelete === "function" && /*#__PURE__*/React.createElement(GhostButton, {
    overrideClassName: cx("flex items-center h-4"),
    onClick: handleClickDelete,
    disabled: disabled,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(Clear, {
    size: "xs",
    className: cx(disabled ? "text-tertiary" : "text-secondary")
  })));
});